declare const google: any;

export function isMapsApiLoaded(): boolean {
    return typeof google === 'object' && typeof google.maps === 'object';
}
